
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import styled from 'styled-components';

import SocialSecurityInput from './SocialSecurityInput.js';

import ContourPath from '../../image/Contour.png';
import EncryptionNumberPath from '../../image/EncryptionNumber.png';

const SocialSecurityInputWapper = forwardRef((props, ref) => {
	const { wrapperClassName, clickCountFn, isOver } = props;
	const [clickCount, setClickCount] = useState(0);

	const oneRef = useRef();
	const twoRef = useRef();
	const threeRef = useRef();
	const fourRef = useRef();
	const fiveRef = useRef();
	const sixRef = useRef();
	const sevenRef = useRef();

	useEffect(() => {
		clickCountFn(wrapperClassName, clickCount);
	}, [clickCount])

	useImperativeHandle(ref, () => ({
		getValue: () => {
			var one = oneRef.current.getValue();
			var two = twoRef.current.getValue();
			var three = threeRef.current.getValue();
			var four = fourRef.current.getValue();
			var five = fiveRef.current.getValue();
			var six = sixRef.current.getValue();
			var seven = sevenRef.current.getValue();

			return one + two + three + four + five + six + '-' + seven + '******';
		},
		isSocialSecurityBlank: () => {
			oneRef.current.isBold();
			twoRef.current.isBold();
			threeRef.current.isBold();
			fourRef.current.isBold();
			fiveRef.current.isBold();
			sixRef.current.isBold();
			sevenRef.current.isBold();
		}
	}));

	function onChangeValue(className) {
		if (className === 'one') twoRef.current.focus();
		else if (className === 'two') threeRef.current.focus();
		else if (className === 'three') fourRef.current.focus();
		else if (className === 'four') fiveRef.current.focus();
		else if (className === 'five') sixRef.current.focus();
		else if (className === 'six') sevenRef.current.focus();
		else if (className === 'seven') setClickCount(clickCount + 1);
	}

	return (
		<InputWrapper isOver={isOver}>
			<SocialSecurityInput ref={oneRef} className='one' onChangeValue={onChangeValue} isOver={isOver}/>
			<SocialSecurityInput ref={twoRef} className='two' onChangeValue={onChangeValue} isOver={isOver}/>
			<SocialSecurityInput ref={threeRef} className='three' onChangeValue={onChangeValue} isOver={isOver}/>
			<SocialSecurityInput ref={fourRef} className='four' onChangeValue={onChangeValue} isOver={isOver}/>
			<SocialSecurityInput ref={fiveRef} className='five' onChangeValue={onChangeValue} isOver={isOver}/>
			<SocialSecurityInput ref={sixRef} className='six' onChangeValue={onChangeValue} isOver={isOver}/>
			<Contour src={ContourPath} isOver={isOver}/>
			<SocialSecurityInput ref={sevenRef} className='seven' onChangeValue={onChangeValue} isOver={isOver}/>
			<EncryptionNumber src={EncryptionNumberPath} isOver={isOver}/>
			<EncryptionNumber src={EncryptionNumberPath} isOver={isOver}/>
			<EncryptionNumber src={EncryptionNumberPath} isOver={isOver}/>
			<EncryptionNumber src={EncryptionNumberPath} isOver={isOver}/>
			<EncryptionNumber src={EncryptionNumberPath} isOver={isOver}/>
			<EncryptionNumber src={EncryptionNumberPath} isOver={isOver}/>
		</InputWrapper>
	) 
})

export default SocialSecurityInputWapper;

const InputWrapper = styled.div`
	display: flex;
	flex-direction: row;

	align-items: center;

	margin-top: ${props => props.isOver ? `12.5px` : `13px`};

	gap: ${props => props.isOver ? `8px` : `5px`};
`;

const Contour = styled.img`
	width: ${props => props.isOver ? `18px` : `8px`};
	height: 2px;
`;

const EncryptionNumber = styled.img`
	width: ${props => props.isOver ? `8px` : `7px`};
	height: ${props => props.isOver ? `8px` : `7px`};
`;